import StaffMemberAttachments from './StaffMemberAttachments.container';

export default StaffMemberAttachments;
